import React from 'react'
import about from "../images/RAV-SE561UP_RAV-TE561AP.png";

function About() {
  return (
    <div>
       
                <div className="album py-2">

                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">
<div className="card-body">
    <h1 className="card-title"><b style={{color:"#F2192E"}}>About Us</b> – Saha Refrigeration & Air Conditions</h1>
    <p className="card-text justify">Saha Refrigeration & Air Conditions is a trusted name in cooling and climate control solutions in Krishnanagar and Mayapur. With years of experience in the refrigeration and air conditioning industry, we are committed to delivering reliable, energy-efficient, and high-quality services to homes, offices, and commercial establishments.</p>
    <p className='justify'>We specialize in the sales, installation, servicing, and maintenance of air conditioners, refrigerators, deep freezers, cold storage units, and other cooling systems. Our skilled technicians ensure prompt service, professional workmanship, and complete customer satisfaction.</p>
    <h5>At Saha Refrigeration & Air Conditions, our mission is simple —</h5>
    <h6><b>✔ Quality Products</b></h6>
    <h6><b>✔ Reliable Service</b></h6>
    <h6><b>✔ Affordable Pricing</b></h6>
    <h6><b>✔ Customer Satisfaction</b></h6>

  </div>

                                </div>
                                    <div className="col-md-5">

  <img src={about} className="card-img-top" alt="about"/>

                                </div>
                                </div>
                                </div>

                            </div>
        
    </div>
  )
}

export default About